import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "@druva-apps/orion/lib/loader";
import { useDispatch } from "react-redux";

import { showAlert } from "slices/alertsSlice";
import useForgotPasswordConfirm from "queryHooks/auth/useForgotPasswordConfirm";
import useEmailForForgotPasswordConfirm from "queryHooks/auth/useEmailForForgotPasswordConfirm";
import { GENERIC_ERROR_MESSAGE } from "consts";

import ActivateForm from "../activation/ActivateForm";

const ForgotPasswordConfirmContainer = ({ token }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { mutateAsync: confirmForgotPassword, isLoading: confirmInProgress } =
    useForgotPasswordConfirm();

  const { data: emailData, isLoading: emailIsLoading } =
    useEmailForForgotPasswordConfirm(token, {
      onError: (e) => {
        if (e.code === "GoAuth-1003") {
          navigate("/password-error");
        } else {
          dispatch(
            showAlert({
              message: e.message || GENERIC_ERROR_MESSAGE,
              type: "danger",
            })
          );
        }
      },
    });

  const confirmHandler = useCallback(
    async ({ password, repeatedPassword }) => {
      try {
        await confirmForgotPassword({ password, repeatedPassword, token });
        dispatch(
          showAlert({
            message:
              "Password changed successfully. Login again with new password",
            type: "success",
          })
        );
        navigate("/auth/login", { replace: true });
      } catch (e) {
        dispatch(
          showAlert({
            message: e.message || GENERIC_ERROR_MESSAGE,
            type: "danger",
          })
        );
      }
    },
    [confirmForgotPassword, dispatch, navigate, token]
  );

  if (confirmInProgress || emailIsLoading) {
    return (
      <div
        className="oui-card-body oui-d-flex oui-align-items-center oui-justify-content-center"
        data-testid="activation-loader-wrapper"
      >
        <Loader isLoading />
      </div>
    );
  }

  return emailData ? (
    <ActivateForm
      isResetPassword
      email={emailData.email}
      onSubmit={confirmHandler}
    />
  ) : null;
};

export default ForgotPasswordConfirmContainer;
